module.exports = __webpack_public_path__ + "img/agreement.e1cca004.png";